(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["customer-video-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cvc-carousel')) return;

    /* Shared by every carousel on the page: only one video plays at a time. */
    let activeVideo = null;
    let preferMuted = false;

    /* A paused video keeps its downloaded data in memory. When another video starts, or a video has
       been paused for a while, its file is released (the card shows its poster again and, on the next
       tap, continues from the same second). This keeps memory and open connections flat however many
       videos a visitor tries. */
    const IDLE_RELEASE_MS = 45000;
    let startCounter = 0;
    const idleTimers = new WeakMap();
    const savedScroll = {};

    const clearIdle = (video) => {
      const timer = idleTimers.get(video);
      if (timer) clearTimeout(timer);
      idleTimers.delete(video);
    };

    const releaseVideo = (video) => {
      clearIdle(video);
      video.dataset.cvcToken = '';   // any tap still waiting for this video is now out of date
      if (!video.getAttribute('src')) return;

      const card = video.closest('[data-cvc-card]');

      video.dataset.cvcResume = video.ended ? '0' : String(video.currentTime || 0);
      if (!video.paused) video.pause();
      video.removeAttribute('src');
      video.load();

      if (card) {
        card.removeAttribute('data-started');
        card.setAttribute('data-state', 'idle');
      }

      if (activeVideo === video) activeVideo = null;
    };

    const releaseLater = (video) => {
      clearIdle(video);
      idleTimers.set(video, setTimeout(() => {
        idleTimers.delete(video);
        if (video.paused) releaseVideo(video);
      }, IDLE_RELEASE_MS));
    };

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class CvcCarousel extends HTMLElement {
      connectedCallback() {
        if (this._ac) return;

        // Wait until the whole carousel has been parsed when the script loads early.
        if (document.readyState === 'loading' && !this.querySelector('[data-cvc-progress]')) {
          this._onReady = () => this._init();
          document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
          return;
        }

        this._init();
      }

      disconnectedCallback() {
        if (this._onReady) {
          document.removeEventListener('DOMContentLoaded', this._onReady);
          this._onReady = null;
        }

        this._destroy();
      }

      _init() {
        if (this._ac || !this.isConnected) return;

        this.rail = this.querySelector('[data-cvc-rail]');
        this.prev = this.querySelector('[data-cvc-prev]');
        this.next = this.querySelector('[data-cvc-next]');
        this.progress = this.querySelector('[data-cvc-progress]');
        this.thumb = this.querySelector('[data-cvc-thumb]');

        if (!this.rail) return;

        this._ac = new AbortController();
        const { signal } = this._ac;

        this._frame = 0;
        this._seeking = false;

        // Scroll position: progress bar and arrows.
        this.rail.addEventListener('scroll', () => this._schedule(), { passive: true, signal });
        window.addEventListener('resize', () => this._schedule(), { signal });

        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(() => this._schedule());
          this._resizeObserver.observe(this.rail);
        }

        if (this.prev) this.prev.addEventListener('click', () => this._page(-1), { signal });
        if (this.next) this.next.addEventListener('click', () => this._page(1), { signal });

        // All card controls through one delegated listener.
        this.addEventListener('click', (event) => this._onClick(event), { signal });
        this.addEventListener('input', (event) => this._onInput(event), { signal });
        this.addEventListener('pointerdown', (event) => {
          if (event.target.closest('[data-cvc-seek]')) this._seeking = true;
        }, { signal });
        document.addEventListener('pointerup', () => { this._seeking = false; }, { signal });

        // Media events do not bubble, so they are caught on the way down.
        const media = { capture: true, signal };
        this.addEventListener('play', (event) => this._onPlay(event), media);
        this.addEventListener('playing', (event) => this._onPlaying(event), media);
        this.addEventListener('pause', (event) => this._onPause(event), media);
        this.addEventListener('ended', (event) => this._onEnded(event), media);
        this.addEventListener('timeupdate', (event) => this._onTime(event), media);
        this.addEventListener('volumechange', (event) => this._onVolume(event), media);
        this.addEventListener('waiting', (event) => this._setState(this._card(event.target), 'loading'), media);
        this.addEventListener('error', (event) => this._onError(event), media);

        // Pause when a video leaves the screen (scrolled away, or swiped out of the row).
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const video = entry.target.querySelector('video');
              if (!entry.isIntersecting && video && !video.paused) video.pause();
            });
          }, { root: null, rootMargin: '200px 0px', threshold: 0 });

          this.querySelectorAll('[data-cvc-card]').forEach((card) => this._io.observe(card));
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this._pauseAll();
        }, { signal });

        window.addEventListener('pagehide', () => this._pauseAll(), { signal });

        // Theme editor: leave when the section is removed; scroll a selected video into view.
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target && event.target.contains(this)) this._destroy();
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target && event.target.closest && event.target.closest('[data-cvc-slide]');
          if (slide && this.contains(slide)) {
            slide.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
          }
        }, { signal });

        this._key = this.getAttribute('data-shopify-editor-block');

        if (this._key && savedScroll[this._key] !== undefined) {
          this.rail.scrollLeft = savedScroll[this._key];
        }

        this._update();
      }

      _destroy() {
        if (!this._ac) return;

        this._ac.abort();
        this._ac = null;

        if (this._resizeObserver) {
          this._resizeObserver.disconnect();
          this._resizeObserver = null;
        }

        if (this._io) {
          this._io.disconnect();
          this._io = null;
        }

        if (this._frame) {
          cancelAnimationFrame(this._frame);
          this._frame = 0;
        }

        this.querySelectorAll('video').forEach(releaseVideo);
      }

      /* ---------- scrolling ---------- */

      _schedule() {
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = 0;
          this._update();
        });
      }

      _update() {
        const rail = this.rail;
        if (!rail) return;

        const max = rail.scrollWidth - rail.clientWidth;
        const scrollable = max > 1;

        if (this._key) savedScroll[this._key] = rail.scrollLeft;

        if (this.progress) {
          this.progress.hidden = !scrollable;
          if (scrollable) this.progress.setAttribute('data-ready', '');
        }
        if (this.prev) this.prev.hidden = !scrollable || rail.scrollLeft <= 1;
        if (this.next) this.next.hidden = !scrollable || rail.scrollLeft >= max - 1;

        if (scrollable && this.thumb) {
          const size = Math.max(0.12, rail.clientWidth / rail.scrollWidth);
          const travel = 1 - size;
          const offset = (rail.scrollLeft / max) * travel;
          this.thumb.style.width = size * 100 + '%';
          this.thumb.style.transform = 'translateX(' + (offset / size) * 100 + '%)';
        }
      }

      _page(direction) {
        const rail = this.rail;
        rail.scrollBy({
          left: direction * rail.clientWidth * 0.85,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      /* ---------- video ---------- */

      _card(node) {
        return node && node.closest ? node.closest('[data-cvc-card]') : null;
      }

      _setState(card, state) {
        if (card) card.setAttribute('data-state', state);
      }

      _pauseAll() {
        this.querySelectorAll('video').forEach((video) => {
          if (!video.paused) video.pause();
        });
      }

      async _start(card) {
        const video = card.querySelector('video');
        if (!video) return;

        clearIdle(video);

        const token = String(++startCounter);
        video.dataset.cvcToken = token;

        // The file is only requested now, on the tap (and again if it was released earlier).
        if (!video.getAttribute('src')) {
          const resume = parseFloat(video.dataset.cvcResume);

          video.setAttribute('src', video.dataset.src);

          if (resume > 0.5) {
            video.addEventListener('loadedmetadata', () => {
              try { video.currentTime = resume; } catch (error) { /* not seekable yet */ }
            }, { once: true });
          }

          video.load();
        }

        video.muted = preferMuted;
        this._setState(card, 'loading');

        try {
          await video.play();
        } catch (error) {
          // The tap was overtaken (another video started, or this one was paused or released): nothing to do.
          if (video.dataset.cvcToken !== token || (error && error.name === 'AbortError')) return;

          // Some browsers refuse sound in this situation: retry silently rather than doing nothing.
          if (!video.muted) {
            video.muted = true;
            try {
              await video.play();
            } catch (retryError) {
              if (video.dataset.cvcToken === token) this._setState(card, 'idle');
            }
          } else {
            this._setState(card, 'idle');
          }
        }
      }

      _onClick(event) {
        const target = event.target;
        const card = this._card(target);
        if (!card) return;

        const video = card.querySelector('video');

        if (target.closest('[data-cvc-play]') || (target.closest('.cvc__poster') && !card.hasAttribute('data-started'))) {
          this._start(card);
        } else if (target.closest('[data-cvc-toggle]')) {
          if (video.paused) this._start(card); else video.pause();
        } else if (target.closest('[data-cvc-mute]')) {
          preferMuted = !video.muted;
          video.muted = preferMuted;
        } else if (target === video && card.hasAttribute('data-started')) {
          if (video.paused) this._start(card); else video.pause();
        }
      }

      _onInput(event) {
        const seek = event.target.closest && event.target.closest('[data-cvc-seek]');
        if (!seek) return;

        const video = this._card(seek).querySelector('video');
        if (Number.isFinite(video.duration) && video.duration > 0) {
          video.currentTime = (seek.value / 1000) * video.duration;
        }
        seek.style.setProperty('--cvc-seek', seek.value / 10 + '%');
      }

      _onPlay(event) {
        const video = event.target;

        // Starting one video stops the previous one and lets go of its file.
        if (activeVideo && activeVideo !== video) releaseVideo(activeVideo);
        activeVideo = video;
        clearIdle(video);

        this._setState(this._card(video), 'playing');
        this._label(this._card(video), false);
      }

      _onPlaying(event) {
        const card = this._card(event.target);
        if (!card) return;

        card.setAttribute('data-started', '');
        this._setState(card, 'playing');
      }

      _onPause(event) {
        const video = event.target;
        const card = this._card(video);

        // Ignore the pause that comes with releasing a video (it no longer has a file)
        if (!card || video.ended || !video.getAttribute('src')) return;

        this._setState(card, 'paused');
        this._label(card, true);
        releaseLater(video);
      }

      _onEnded(event) {
        const video = event.target;
        const card = this._card(video);
        if (!card) return;

        video.currentTime = 0;
        this._setState(card, 'paused');
        this._label(card, true);
        releaseLater(video);
      }

      _onTime(event) {
        if (this._seeking) return;

        const video = event.target;
        const card = this._card(video);
        const seek = card && card.querySelector('[data-cvc-seek]');

        if (seek && Number.isFinite(video.duration) && video.duration > 0) {
          const value = Math.round((video.currentTime / video.duration) * 1000);
          seek.value = value;
          seek.style.setProperty('--cvc-seek', value / 10 + '%');
        }
      }

      _onVolume(event) {
        const video = event.target;
        const button = this._card(video) && this._card(video).querySelector('[data-cvc-mute]');
        if (!button) return;

        button.setAttribute('aria-pressed', String(video.muted));
        button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }

      _onError(event) {
        const card = this._card(event.target);
        if (card && event.target.tagName === 'VIDEO') {
          card.removeAttribute('data-started');
          this._setState(card, 'idle');
        }
      }

      _label(card, paused) {
        const button = card && card.querySelector('[data-cvc-toggle]');
        if (button) button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      }
    }

    customElements.define('cvc-carousel', CvcCarousel);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nova-free-bonuses-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('nfbc-carousel')) return;

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));

    class NfbcCarousel extends HTMLElement {
      connectedCallback() {
        if (this._ac) return;

        // The script can run before the markup below this element has been parsed.
        if (document.readyState === 'loading' && !this.querySelector('[data-nfbc-rail]')) {
          this._onReady = () => this._init();
          document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
          return;
        }

        this._init();
      }

      disconnectedCallback() {
        if (this._onReady) {
          document.removeEventListener('DOMContentLoaded', this._onReady);
          this._onReady = null;
        }

        this._destroy();
      }

      _init() {
        if (this._ac || !this.isConnected) return;

        this.rail = this.querySelector('[data-nfbc-rail]');
        if (!this.rail) return;

        this.prevBtn = this.querySelector('[data-nfbc-prev]');
        this.nextBtn = this.querySelector('[data-nfbc-next]');
        this.counter = this.querySelector('[data-nfbc-counter]');
        this.progress = this.querySelector('[data-nfbc-progress]');
        this.live = this.querySelector('[data-nfbc-live]');

        this._ac = new AbortController();
        const { signal } = this._ac;

        this._idx = 0;
        this._target = 0;
        this._n = 0;
        this._h = 0;
        this._segCount = this.progress ? this.progress.children.length : 0;
        this._navActive = false;
        this._silent = true; // nothing is announced for the first state
        this._raf = 0;
        this._settleTimer = 0;

        this.rail.addEventListener('scroll', () => this._onScroll(), { passive: true, signal });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._step(-1), { signal });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._step(1), { signal });
        this.addEventListener('keydown', (event) => this._onKey(event), { signal });

        // Keep the current slide aligned, and the row the right height, when the column or the slide content changes.
        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(() => {
            // Work happens in the next frame, outside the observer callback, so changing the row height here can
            // never re-trigger it (no "ResizeObserver loop" warning).
            cancelAnimationFrame(this._roFrame);
            this._roFrame = requestAnimationFrame(() => this._onResize());
          });
          this._resizeObserver.observe(this.rail);
          this._observed = new Set();
        }

        // Slides added, removed, hidden or re-rendered (Theme Editor).
        if ('MutationObserver' in window) {
          this._mutationObserver = new MutationObserver(() => this._schedule(true));
          this._mutationObserver.observe(this.rail, { childList: true });
        }

        // Coming back to the page from the back/forward cache: start again on the first slide.
        window.addEventListener('pageshow', (event) => { if (event.persisted) this._reset(); }, { signal });

        // Theme Editor: show the selected slide, and let go when the section is removed.
        document.addEventListener('shopify:block:select', (event) => {
          const target = event.target;
          const slide = target && target.closest ? target.closest('[data-nfbc-slide]') : null;
          if (!slide || !this.contains(slide)) return;
          const index = this._slides().indexOf(slide);
          if (index >= 0) this.go(index, { instant: true, silent: true });
        }, { signal });

        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target && event.target.contains(this)) this._destroy();
        }, { signal });

        this._reset();
        this.setAttribute('data-nfbc-ready', '');
      }

      _destroy() {
        if (!this._ac) return;
        this._ac.abort();
        this._ac = null;
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._mutationObserver) this._mutationObserver.disconnect();
        cancelAnimationFrame(this._raf);
        cancelAnimationFrame(this._roFrame);
        clearTimeout(this._settleTimer);
        this._resizeObserver = null;
        this._mutationObserver = null;
        this._observed = null;
        if (this.rail) this.rail.style.height = '';
      }

      /* The slides that really rendered, in the order the customer sees them: CSS order first (Warranty = -1),
         then page order. A second slide of the same type is a configuration slip, so it is set aside (hidden)
         here, on purpose, by type. Slides of different types are never touched. */
      _slides() {
        const all = Array.from(this.rail.querySelectorAll(':scope > [data-nfbc-slide]'));
        const seen = new Set();

        all.forEach((el) => {
          const type = el.getAttribute('data-nfbc-type') || '';
          if (seen.has(type)) {
            el.hidden = true;
            el.setAttribute('data-nfbc-duplicate', '');
          } else {
            seen.add(type);
            if (el.hasAttribute('data-nfbc-duplicate')) {
              el.hidden = false;
              el.removeAttribute('data-nfbc-duplicate');
            }
          }
        });

        return all
          .filter((el) => !el.hidden && el.getClientRects().length > 0)
          .map((el, i) => ({ el, i, o: parseInt(getComputedStyle(el).order, 10) || 0 }))
          .sort((a, b) => a.o - b.o || a.i - b.i)
          .map((item) => item.el);
      }

      _setDisabled(button, disabled) {
        if (button) button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }

      _buildSegments(n) {
        if (!this.progress || this._segCount === n) return;
        while (this.progress.children.length > n) this.progress.lastElementChild.remove();
        while (this.progress.children.length < n) {
          const seg = document.createElement('span');
          seg.className = 'nfbc__seg';
          this.progress.appendChild(seg);
        }
        this._segCount = n;
      }

      /* Row height = height of the slide on show. Eased when the slide changes, instant on first fit and resize. */
      _fit(idx, instant) {
        const slide = this._list && this._list[idx];
        if (!slide) return;

        const height = Math.ceil(slide.getBoundingClientRect().height);
        if (!height || height === this._h) return;

        const rail = this.rail;
        if (instant || reduceMotion() || !this.hasAttribute('data-nfbc-ready')) {
          rail.style.transition = 'none';
          rail.style.height = `${height}px`;
          void rail.offsetHeight;
          rail.style.transition = '';
        } else {
          rail.style.height = `${height}px`;
        }
        this._h = height;
      }

      /* Reads the slides, labels them, and paints the counter, segments and arrows. Returns the current index. */
      _update(instant) {
        const slides = this._slides();
        const n = slides.length;
        this._list = slides;
        this._n = n;

        this.toggleAttribute('data-nfbc-single', n < 2);
        this._buildSegments(n);

        slides.forEach((slide, i) => slide.setAttribute('aria-label', `${i + 1} of ${n}`));

        if (this._resizeObserver) {
          slides.forEach((slide) => {
            if (!this._observed.has(slide)) {
              this._observed.add(slide);
              this._resizeObserver.observe(slide);
            }
          });
        }

        const width = this.rail.clientWidth || 1;
        const idx = n ? clamp(Math.round(this.rail.scrollLeft / width), 0, n - 1) : 0;
        this._paint(idx, n);
        this._fit(idx, instant);
        return idx;
      }

      _paint(idx, n) {
        if (this.progress) {
          Array.from(this.progress.children).forEach((seg, i) => seg.classList.toggle('is-active', i === idx));
        }
        if (this.counter) this.counter.textContent = `${idx + 1} / ${n}`;
        this._setDisabled(this.prevBtn, idx <= 0);
        this._setDisabled(this.nextBtn, idx >= n - 1);
      }

      _schedule(instant) {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          const idx = this._update(instant === true);
          if (idx !== this._idx) {
            this._idx = idx;
            this._pending = true;
          }
        });
      }

      _onScroll() {
        this._schedule();
        this._armSettle(140);
      }

      _armSettle(ms) {
        clearTimeout(this._settleTimer);
        this._settleTimer = setTimeout(() => this._settled(), ms);
      }

      /* The scroll has stopped: say the new slide once (not once per slide passed on a fast swipe). */
      _settled() {
        this._navActive = false;
        const idx = this._update();
        this._target = idx;
        if (idx !== this._idx) {
          this._idx = idx;
          this._pending = true;
        }
        if (this._pending && !this._silent) this._announce(idx);
        this._pending = false;
        this._silent = false;
      }

      _announce(idx) {
        if (!this.live) return;
        const slides = this._slides();
        const slide = slides[idx];
        const title = slide ? slide.querySelector('[data-nfbc-title]') : null;
        const label = title ? `: ${title.textContent.trim()}` : '';
        this.live.textContent = `Bonus ${idx + 1} of ${slides.length}${label}`;
      }

      _onResize() {
        if (this._navActive) return;
        const width = this.rail.clientWidth;
        const idx = clamp(this._idx, 0, Math.max(this._n - 1, 0));
        if (width && Math.abs(this.rail.scrollLeft - idx * width) > 1) {
          this.rail.scrollTo({ left: idx * width, behavior: 'auto' });
        }
        this._h = 0;
        this._update(true);
      }

      _reset() {
        this._silent = true;
        this._navActive = false;
        this._idx = 0;
        this._target = 0;
        this._h = 0;
        this.rail.scrollTo({ left: 0, behavior: 'auto' });
        this._update(true);
        if (this.live) this.live.textContent = '';
        this._armSettle(80); // clears the "silent" state even when the rail did not have to move
      }

      go(index, options = {}) {
        const n = this._n || this._slides().length;
        if (!n) return;

        const i = clamp(index, 0, n - 1);
        this._target = i;
        this._navActive = true;
        if (options.silent) this._silent = true;

        const behavior = options.instant || reduceMotion() ? 'auto' : 'smooth';
        this.rail.scrollTo({ left: i * this.rail.clientWidth, behavior });

        // If the position does not change there is no scroll event, so settle on a timer as well.
        this._armSettle(behavior === 'smooth' ? 500 : 60);
      }

      /* Repeated clicks keep moving from where the last click was heading, not from where the slide is mid-glide. */
      _step(direction) {
        const base = this._navActive ? this._target : this._idx;
        this._silent = false;
        this.go(base + direction);
      }

      _onKey(event) {
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (getComputedStyle(this).direction === 'rtl') return;

        let handled = true;
        if (event.key === 'ArrowLeft') this._step(-1);
        else if (event.key === 'ArrowRight') this._step(1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this._n - 1);
        else handled = false;

        if (handled) event.preventDefault();
      }
    }

    customElements.define('nfbc-carousel', NfbcCarousel);
  })();
  } catch(e) { console.error(e); }
})();

})();
